import React, { useState } from 'react';
import { Button, Menu, Popover, Tooltip } from 'antd';
import { PlusOutlined,
         ArrowRightOutlined,
         ContainerOutlined,
         PercentageOutlined } from '@ant-design/icons';
import uuid from 'react-uuid';
import { withoutId } from '../../utils/data.js';
import AccountBasedProRataSplitSubMenu from './AccountBasedProRataSplitSubMenu.js'
import PercentageSplitSubmenu from './PercentageSplitSubmenu.js';
import { AccountProRataFunction, PercentageSplitFunction } from '@lrea/ri-shared';

function CompoundSplitRowMenu(props) {
  const [open, setOpen] = useState(false);

  const [width, setWidth] = useState(400);
  const [height, setHeight] = useState(250);

  function handleClick(e) {
    const func = props.row.func;
    const clone = func.clone(func.id, func.target);
        
    const split_type = e.key;
    
    let split = '';
    if (split_type === 'percentage') {
      clone.functions.push(new PercentageSplitFunction(func.id, func.pullId, func.target, true, 0, 0, 0));
      split = clone.getSplit();
    } else if (split_type === 'account-pro-rata') {
      clone.functions.push(new AccountProRataFunction(func.id, func.pullId, func.target, true));
      split = clone.getSplit();
    }

    const newSplits = [...withoutId(props.model.splitState, split.id), split];
    props.setSplitsState(newSplits);

    setOpen(false);
  }

  function updateSubSplit(subSplit) {
    const split = props.row.split;
    const meta = JSON.parse(split.split_meta);
    const newMeta = meta.filter(i => i.split_index !== subSplit.split_index);
    newMeta.push(subSplit);

    split.split_meta = JSON.stringify(newMeta);
    split.updated = true;

    const newSplits = [...withoutId(props.model.splits.splitState, split.id), split];
    props.setSplitsState(newSplits);
  }
  
  function renderPercentageControls() {
    return <PercentageSplitSubmenu      
      row={props.row}
      setMenuVisible={() => {}}
      setPercentageVisible={setOpen}
      compoundIndex={props.record.index}
      setOpen={setOpen}
      onPercentageChange={(column, value) => { props.onPercentageChange(props.record.index, column, value) }}
    />
  }
 
  function renderAccountProRataControls() {
    return <AccountBasedProRataSplitSubMenu
      model={props.model}
      row={props.row}
      compoundIndex={props.record.index}
      setMenuVisible={setOpen}
      setSplitsState={props.setSplitsState}
      setAccountProRataVisible={setOpen}/>
  }

  function renderNewSplitMenu() {
    return (
      <Menu mode="vertical">
        <Menu.Item key="percentage"
          icon={<PercentageOutlined />}
          onClick={handleClick}>
          Percentage Split
        </Menu.Item>
        <Menu.Item key="account-pro-rata"
          icon={<ContainerOutlined />}
          onClick={handleClick}>
          Account Based Pro-Rata
        </Menu.Item>
      </Menu>
    );
  }

  function renderPopeverContent() {
    let childContent = null;

    if (props.record.row_type === 'footer') {
      setHeight(100);
      setWidth(300);
      childContent = renderNewSplitMenu();
    } else if (props.record.row_type === 'subSplit') {
      if (props.record.split_type === 'percentage') {
        setHeight(220);
        setWidth(400);
        childContent = renderPercentageControls();
      } else if (props.record.split_type === 'account-pro-rata') {
        setHeight(400);
        setWidth(800);
        childContent = renderAccountProRataControls();
      }
    }

    return (
      <div style={{height: height, width: width}}>
        {childContent}
      </div>
    );
  }

  function onOpenChange(openState) {
    if (props.record.row_type === 'header') {
      return;
    }

    setOpen(openState);
  }

  function renderIcon() {
    if (props.record.row_type === 'header') {
      return <ArrowRightOutlined style={{ color: 'green' }} />
    }
    else if (props.record.row_type === 'footer') {
      return <PlusOutlined style={{ color: 'green' }} />
    } else if (props.record.row_type === 'subSplit') {
      if (props.record.split_type === 'percentage') {
        return <PercentageOutlined style={{ color: 'blue' }} />
      } else if (props.record.split_type === 'account-pro-rata') {
        return <ContainerOutlined style={{ color: 'blue' }} />
      }
    }
  }

  function getTooltipText() {
    if (props.record.row_type === 'header') {
      return "This line shows the total value for the account.";
    }
    else if (props.record.row_type === 'footer') {
      return "Add New Compound Split Line"
    }
    else if (props.record.row_type === 'subSplit') {
      if (props.record.split_type === 'percentage') {
        return 'Percentage Split'
      } else if (props.record.split_type === 'account-pro-rata') {
        return 'Account Based Pro Rata Split'
      }
    }

    return '';
  }

  return (
    <Tooltip title={getTooltipText()} key={props.row.id}>
      <Popover content={() => renderPopeverContent()}
        trigger="click"
        open={open}
        onOpenChange={onOpenChange}>
        <Button shape="circle" size="small"
          icon={renderIcon()} />
      </Popover>
    </Tooltip>
  );
}

export default CompoundSplitRowMenu;
